module.exports = __webpack_public_path__ + "img/checkvert_on.bb88dbf2.gif";